import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getCreatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { RewardConfigureFormContainer } from '../components/RewardConfigureForm/RewardConfigureFormContainer';
import { messages } from '../messages';

export const RewardConfigurePageContainer: React.FC = () => {
  const { id: campaignId = '', rewardId = '' } = useParams<{ id: string; rewardId: string }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);

  return (
    <OfferConfigurePageContainer
      campaignId={campaignId}
      offerId={rewardId}
      getBreadcrumbLinks={(offerName) => getCreatePageLinks(campaignId, campaignName, offerName)}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Reward}
      targetTabProps={{
        shouldShowStateRestrictions: false,
        shouldShowStoreLocationOrGroups: false,
      }}
      ConfigureFormContainer={RewardConfigureFormContainer}
    />
  );
};
